import * as R from 'ramda'

import enums from 'shared/enums'

import { createSelector } from 'reselect'
import { path, pathOr, includes } from 'ramda'

const NETWORK_PATH = ['network']
const ID_PATH = [...NETWORK_PATH, ':db/id']
const UUID_PATH = [...NETWORK_PATH, ':network/squuid']
const NAME_PATH = [...NETWORK_PATH, ':network/name']
const TITLE_PATH = [...NETWORK_PATH, ':network/title']
const LTI_CREDS_PATH = [...NETWORK_PATH, ':network/lti-credentials']
const PENDING_BOARDS_PATH = [...NETWORK_PATH, '@network/pending-boards']
const PENDING_BOARD_COUNT_PATH = [
  ...NETWORK_PATH,
  '@network/count-pending-boards'
]
const SUB_NETWORKS_PATH = [...NETWORK_PATH, '@network/sub-networks']
const NETWORK_ACTIVITY_PATH = [...NETWORK_PATH, '@network/activity']
const TIMEZONE_PATH = [...NETWORK_PATH, '@network/timezone']
const BRAND_COLOR_PATH = [...NETWORK_PATH, '@network/brand-color']
const FEATURES_PATH = [...NETWORK_PATH, ':network/features']
const NETWORK_SETTINGS_PATH = [...NETWORK_PATH, ':network/settings']
const CONTRACT_END_DATE_PATH = [...NETWORK_PATH, '@network/contract-end-date']
const NETWORK_ADMIN_PATH = [...NETWORK_PATH, 'isNetworkAdmin']
const HIDE_BRANDING_PATH = [
  ...NETWORK_SETTINGS_PATH,
  ':network-settings/hide-branding'
]

export const networkSelector = pathOr({}, NETWORK_PATH)
export const idSelector = path(ID_PATH)
export const uuidSelector = path(UUID_PATH)
export const nameSelector = path(NAME_PATH)
export const titleSelector = path(TITLE_PATH)
export const pendingBoardsSelector = pathOr([], PENDING_BOARDS_PATH)
export const networkPendingBoardCountSelector = pathOr(
  0,
  PENDING_BOARD_COUNT_PATH
)
export const subNetworksSelector = pathOr([], SUB_NETWORKS_PATH)
export const networkActivitySelector = path(NETWORK_ACTIVITY_PATH)
export const ltiCredentialsSelector = pathOr([], LTI_CREDS_PATH)
export const networkTimezoneSelector = pathOr('America/New_York', TIMEZONE_PATH)
export const brandColorSelector = path(BRAND_COLOR_PATH)
/** @public to be deprecated */
export const featuresSelector = pathOr([], FEATURES_PATH)
export const hideBrandingSelector = pathOr(false, HIDE_BRANDING_PATH)
export const contractEndDateSelector = pathOr(null, CONTRACT_END_DATE_PATH)
export const isNetworkAdminSelector = pathOr(false, NETWORK_ADMIN_PATH)

export const networkFeatureEnabledFactory = featureKw =>
  createSelector(
    networkSelector,
    network =>
      network && includes(featureKw, network[':network/features'] || [])
  )

export const dateFormatSelector = createSelector(networkSelector, network => {
  const defaultFormats = R.values(enums[':network-settings/date-format'])
  const networkFormat = R.prop('@network/date-format', network)
  if (networkFormat && R.includes(networkFormat, defaultFormats)) {
    return networkFormat
  }
})

export const dateFormatWithoutTimeSelector = createSelector(
  dateFormatSelector,
  format => format && R.head(R.split(' ', format))
)
